<script>
    export let scope
</script>

<div>
    <div class="ui basic vertical segment">
        <div class="ui toggle big checkbox">
            <input type="radio" bind:group={scope} value="SAR">
            <label>Acesso</label>
        </div>
    </div>
    <div class="ui basic vertical segment">
        <div class="ui toggle big checkbox">
            <input type="radio" bind:group={scope} value="DDR">
            <label>Remoção</label>
        </div>
    </div>
    <div class="ui basic vertical segment">
        <div class="ui toggle big checkbox">
            <input type="radio" bind:group={scope} value="RET">
            <label>Retificação</label>
        </div>
    </div>
</div>
